import i18next from 'i18next';

export const resources = {
  en: {
    translation: {
      "title": "RunSpine - Online Spine Animation Viewer",
      "spineList": "Spine List",
      "loadLocal": "Load Local",
      "pmaTitle": "Premultiplied Alpha",
      "pma": "P",
      "bonesTitle": "Show Bones",
      "bones": "B",
      "boundsTitle": "Show Bounds",
      "bounds": "B",
      "fullscreenTitle": "Fullscreen (F11)",
      "reset": "Reset",
      "playback": "Playback",
      "viewSettings": "View Settings",
      "basicInfo": "Basic Info",
      "skin": "Skin:",
      "animation": "Animation:",
      "default": "Default",
      "scaleRange": "Scale Range:",
      "min": "Min:",
      "max": "Max:",
      "speedRange": "Speed Range:",
      "fullscreenSettings": "Fullscreen:",
      "standardFs": "Standard",
      "borderlessFs": "Borderless",
      "hideUiFs": "Hide UI in Fullscreen",
      "welcomeTitle": "RunSpine Viewer",
      "tip1": "👉 Space to Play/Pause",
      "tip2": "📂 Drag & drop folder here, or click Load Local",
      "tip3": "🔧 Supported versions: 3.8, 4.0, 4.1, 4.2",
      "ad": "Advertisement",
      "errorMissingFiles": "Please provide a complete set of Spine files: includes .skel or .json, .atlas, and all required .png files.",
      "resourceInfo": "Resource Info",
      "name": "Name",
      "skeleton": "Skeleton",
      "atlas": "Atlas",
      "source": "Source",
      "sourceLocal": "Local File",
      "sourceManifest": "Manifest",
      "spineVersion": "Spine Version",
      "runtimeVersion": "Runtime Version",
      "atlasPages": "Atlas Pages",
      "totalSize": "Total Size",
      "animationCount": "Animation Count",
      "skinCount": "Skin Count",
      "playbackState": "Playback State",
      "duration": "Duration:",
      "time": "Time:",
      "errorInfo": "Error Info",
      "readError": "Failed to read file: ",
      "hintZoom": "Scroll to Zoom",
      "hintPause": "Space to Play/Pause",
      "dropHere": "Release mouse to load files",
      "notDetected": "Not detected"
    }
  },
  zh: {
    translation: {
      "title": "RunSpine - 在线 Spine 动画预览工具",
      "spineList": "Spine 列表",
      "loadLocal": "加载本地",
      "pmaTitle": "预乘 Alpha",
      "pma": "预",
      "bonesTitle": "显示骨骼",
      "bones": "骨",
      "boundsTitle": "显示包围盒",
      "bounds": "盒",
      "fullscreenTitle": "全屏 (F11)",
      "reset": "重置",
      "playback": "播放控制",
      "viewSettings": "视图设置",
      "basicInfo": "基础信息",
      "skin": "皮肤:",
      "animation": "动画:",
      "default": "默认",
      "scaleRange": "缩放范围:",
      "min": "最小:",
      "max": "最大:",
      "speedRange": "倍速范围:",
      "fullscreenSettings": "全屏设置:",
      "standardFs": "标准全屏",
      "borderlessFs": "无边框",
      "hideUiFs": "全屏时隐藏其他UI",
      "welcomeTitle": "RunSpine 预览器",
      "tip1": "👉 空格键 播放/暂停",
      "tip2": "📂 拖拽文件夹到此处加载，或点击加载本地",
      "tip3": "🔧 支持版本: 3.8, 4.0, 4.1, 4.2",
      "ad": "Advertisement",
      "errorMissingFiles": "请提供完整的 Spine 文件集：包含 .skel 或 .json、.atlas 以及所有需要的 .png 文件。",
      "resourceInfo": "资源信息",
      "name": "名称",
      "skeleton": "骨架",
      "atlas": "图集",
      "source": "来源",
      "sourceLocal": "本地文件",
      "sourceManifest": "manifest",
      "spineVersion": "Spine 版本",
      "runtimeVersion": "运行时版本",
      "atlasPages": "图集页数",
      "totalSize": "总大小",
      "animationCount": "动画数量",
      "skinCount": "皮肤数量",
      "playbackState": "播放状态",
      "duration": "时长:",
      "time": "时间:",
      "errorInfo": "错误信息",
      "readError": "读取文件失败: ",
      "hintZoom": "滚轮缩放",
      "hintPause": "空格暂停/播放",
      "dropHere": "松开鼠标以加载文件",
      "notDetected": "未检测到"
    }
  },
  ja: {
    translation: {
      "title": "RunSpine - オンラインSpineアニメーションビューア",
      "spineList": "Spineリスト",
      "loadLocal": "ローカル読込",
      "pmaTitle": "乗算済みアルファ",
      "pma": "ア",
      "bonesTitle": "ボーンを表示",
      "bones": "骨",
      "boundsTitle": "バウンディングボックスを表示",
      "bounds": "枠",
      "fullscreenTitle": "フルスクリーン (F11)",
      "reset": "リセット",
      "playback": "再生制御",
      "viewSettings": "表示設定",
      "basicInfo": "基本情報",
      "skin": "スキン:",
      "animation": "アニメーション:",
      "default": "デフォルト",
      "scaleRange": "ズーム範囲:",
      "min": "最小:",
      "max": "最大:",
      "speedRange": "速度範囲:",
      "fullscreenSettings": "フルスクリーン:",
      "standardFs": "標準",
      "borderlessFs": "ボーダーレス",
      "hideUiFs": "他のUIを隠す",
      "welcomeTitle": "RunSpine ビューア",
      "tip1": "👉 スペースキーで再生/一時停止",
      "tip2": "📂 フォルダをドラッグ＆ドロップ、またはローカル読込",
      "tip3": "🔧 対応バージョン: 3.8, 4.0, 4.1, 4.2",
      "ad": "広告",
      "errorMissingFiles": "完全なSpineファイルセットを提供してください（.skelまたは.json、.atlas、および必要なすべての.pngファイル）。",
      "resourceInfo": "リソース情報",
      "name": "名前",
      "skeleton": "スケルトン",
      "atlas": "アトラス",
      "source": "ソース",
      "sourceLocal": "ローカルファイル",
      "sourceManifest": "マニフェスト",
      "spineVersion": "Spine バージョン",
      "runtimeVersion": "ランタイムバージョン",
      "atlasPages": "アトラスページ数",
      "totalSize": "合計サイズ",
      "animationCount": "アニメーション数",
      "skinCount": "スキン数",
      "playbackState": "再生状態",
      "duration": "長さ:",
      "time": "時間:",
      "errorInfo": "エラー情報",
      "readError": "ファイルの読み込みに失敗しました: ",
      "hintZoom": "スクロールでズーム",
      "hintPause": "スペースで再生/一時停止",
      "dropHere": "マウスを離してファイルを読み込む",
      "notDetected": "未検出"
    }
  },
  ko: {
    translation: {
      "title": "RunSpine - 온라인 Spine 애니메이션 뷰어",
      "spineList": "Spine 목록",
      "loadLocal": "로컬 불러오기",
      "pmaTitle": "미리 곱해진 알파",
      "pma": "알",
      "bonesTitle": "뼈대 보기",
      "bones": "뼈",
      "boundsTitle": "경계 상자 보기",
      "bounds": "상",
      "fullscreenTitle": "전체 화면 (F11)",
      "reset": "초기화",
      "playback": "재생 제어",
      "viewSettings": "보기 설정",
      "basicInfo": "기본 정보",
      "skin: ": "스킨:",
      "animation: ": "애니메이션:",
      "default": "기본값",
      "scaleRange": "확대/축소 범위:",
      "min": "최소:",
      "max": "최대:",
      "speedRange": "속도 범위:",
      "fullscreenSettings": "전체 화면 설정:",
      "standardFs": "표준",
      "borderlessFs": "테두리 없음",
      "hideUiFs": "다른 UI 숨기기",
      "welcomeTitle": "RunSpine 뷰어",
      "tip1": "👉 스페이스바로 재생/일시정지",
      "tip2": "📂 폴더를 여기에 드래그 앤 드롭하거나 로컬 불러오기 클릭",
      "tip3": "🔧 지원 버전: 3.8, 4.0, 4.1, 4.2",
      "ad": "광고",
      "errorMissingFiles": "완전한 Spine 파일 세트를 제공하십시오: .skel 또는 .json, .atlas 및 필요한 모든 .png 파일 포함.",
      "resourceInfo": "리소스 정보",
      "name": "이름",
      "skeleton": "스켈레톤",
      "atlas": "아틀라스",
      "source": "출처",
      "sourceLocal": "로컬 파일",
      "sourceManifest": "매니페스트",
      "spineVersion": "Spine 버전",
      "runtimeVersion": "런타임 버전",
      "atlasPages": "아틀라스 페이지 수",
      "totalSize": "총 크기",
      "animationCount": "애니메이션 수",
      "skinCount": "스킨 수",
      "playbackState": "재생 상태",
      "duration": "길이:",
      "time": "시간:",
      "errorInfo": "에러 정보",
      "readError": "파일 읽기 실패: ",
      "hintZoom": "스크롤하여 줌",
      "hintPause": "스페이스바로 재생/일시정지",
      "dropHere": "마우스를 놓아 파일 로드",
      "notDetected": "감지되지 않음"
    }
  },
  es: {
    translation: {
      "title": "RunSpine - Visor de Animación Spine Online",
      "spineList": "Lista Spine",
      "loadLocal": "Cargar Local",
      "pmaTitle": "Alfa Premultiplicado",
      "pma": "P",
      "bonesTitle": "Mostrar Huesos",
      "bones": "H",
      "boundsTitle": "Mostrar Límites",
      "bounds": "L",
      "fullscreenTitle": "Pantalla Completa (F11)",
      "reset": "Reiniciar",
      "playback": "Reproducción",
      "viewSettings": "Ajustes de Vista",
      "basicInfo": "Info Básica",
      "skin": "Piel:",
      "animation": "Animación:",
      "default": "Por defecto",
      "scaleRange": "Rango de Escala:",
      "min": "Mín:",
      "max": "Máx:",
      "speedRange": "Rango de Velocidad:",
      "fullscreenSettings": "Pantalla Completa:",
      "standardFs": "Estándar",
      "borderlessFs": "Sin Bordes",
      "hideUiFs": "Ocultar UI",
      "welcomeTitle": "Visor RunSpine",
      "tip1": "👉 Espacio para Reproducir/Pausar",
      "tip2": "📂 Arrastra la carpeta aquí o haz clic en Cargar Local",
      "tip3": "🔧 Versiones soportadas: 3.8, 4.0, 4.1, 4.2",
      "ad": "Anuncio",
      "errorMissingFiles": "Por favor, proporcione un conjunto completo de archivos Spine: incluye .skel o .json, .atlas y todos los archivos .png requeridos.",
      "resourceInfo": "Información de Recursos",
      "name": "Nombre",
      "skeleton": "Esqueleto",
      "atlas": "Atlas",
      "source": "Fuente",
      "sourceLocal": "Archivo Local",
      "sourceManifest": "Manifiesto",
      "spineVersion": "Versión Spine",
      "runtimeVersion": "Versión Runtime",
      "atlasPages": "Páginas del Atlas",
      "totalSize": "Tamaño Total",
      "animationCount": "Cantidad de Animaciones",
      "skinCount": "Cantidad de Pieles",
      "playbackState": "Estado de Reproducción",
      "duration": "Duración:",
      "time": "Tiempo:",
      "errorInfo": "Información de Error",
      "readError": "Fallo al leer el archivo: ",
      "hintZoom": "Desplázate para hacer zoom",
      "hintPause": "Espacio para Pausar",
      "dropHere": "Suelta el ratón para cargar archivos",
      "notDetected": "No detectado"
    }
  },
  fr: {
    translation: {
      "title": "RunSpine - Visionneuse d'Animation Spine",
      "spineList": "Liste Spine",
      "loadLocal": "Charger Local",
      "pmaTitle": "Alpha Prémultiplié",
      "pma": "P",
      "bonesTitle": "Afficher les Os",
      "bones": "O",
      "boundsTitle": "Afficher les Limites",
      "bounds": "L",
      "fullscreenTitle": "Plein Écran (F11)",
      "reset": "Réinitialiser",
      "playback": "Lecture",
      "viewSettings": "Paramètres d'Affichage",
      "basicInfo": "Infos de Base",
      "skin": "Peau:",
      "animation": "Animation:",
      "default": "Défaut",
      "scaleRange": "Plage d'Échelle:",
      "min": "Min:",
      "max": "Max:",
      "speedRange": "Plage de Vitesse:",
      "fullscreenSettings": "Plein Écran:",
      "standardFs": "Standard",
      "borderlessFs": "Sans Bordure",
      "hideUiFs": "Masquer l'UI",
      "welcomeTitle": "Visionneuse RunSpine",
      "tip1": "👉 Espace pour Lecture/Pause",
      "tip2": "📂 Glissez-déposez le dossier ici, ou cliquez sur Charger Local",
      "tip3": "🔧 Versions supportées: 3.8, 4.0, 4.1, 4.2",
      "ad": "Publicité",
      "errorMissingFiles": "Veuillez fournir un ensemble complet de fichiers Spine : inclut .skel ou .json, .atlas, et tous les fichiers .png requis.",
      "resourceInfo": "Infos sur les Ressources",
      "name": "Nom",
      "skeleton": "Squelette",
      "atlas": "Atlas",
      "source": "Source",
      "sourceLocal": "Fichier Local",
      "sourceManifest": "Manifeste",
      "spineVersion": "Version Spine",
      "runtimeVersion": "Version Runtime",
      "atlasPages": "Pages de l'Atlas",
      "totalSize": "Taille Totale",
      "animationCount": "Nombre d'Animations",
      "skinCount": "Nombre de Peaux",
      "playbackState": "État de Lecture",
      "duration": "Durée:",
      "time": "Temps:",
      "errorInfo": "Infos d'Erreur",
      "readError": "Échec de la lecture du fichier : ",
      "hintZoom": "Faire défiler pour zoomer",
      "hintPause": "Espace pour Jouer/Pause",
      "dropHere": "Relâchez la souris pour charger",
      "notDetected": "Non détecté"
    }
  },
  de: {
    translation: {
      "title": "RunSpine - Online Spine Animation Viewer",
      "spineList": "Spine-Liste",
      "loadLocal": "Lokal Laden",
      "pmaTitle": "Vormultiplizierter Alpha",
      "pma": "V",
      "bonesTitle": "Knochen Anzeigen",
      "bones: ": "K",
      "boundsTitle": "Grenzen Anzeigen",
      "bounds": "G",
      "fullscreenTitle": "Vollbild (F11)",
      "reset": "Zurücksetzen",
      "playback": "Wiedergabe",
      "viewSettings": "Ansicht",
      "basicInfo": "Basisinfo",
      "skin": "Skin:",
      "animation": "Animation:",
      "default": "Standard",
      "scaleRange": "Skalierungsbereich:",
      "min": "Min:",
      "max": "Max:",
      "speedRange": "Geschwindigkeitsbereich:",
      "fullscreenSettings": "Vollbild:",
      "standardFs": "Standard",
      "borderlessFs": "Randlos",
      "hideUiFs": "UI Ausblenden",
      "welcomeTitle": "RunSpine Viewer",
      "tip1": "👉 Leertaste für Wiedergabe/Pause",
      "tip2": "📂 Ordner hier ablegen oder Lokal Laden klicken",
      "tip3": "🔧 Unterstützte Versionen: 3.8, 4.0, 4.1, 4.2",
      "ad": "Werbung",
      "errorMissingFiles": "Bitte stellen Sie ein komplettes Spine-Dateiset bereit: enthält .skel oder .json, .atlas und alle erforderlichen .png-Dateien.",
      "resourceInfo": "Ressourceninfo",
      "name": "Name",
      "skeleton": "Skelett",
      "atlas": "Atlas",
      "source": "Quelle",
      "sourceLocal": "Lokale Datei",
      "sourceManifest": "Manifest",
      "spineVersion": "Spine-Version",
      "runtimeVersion": "Runtime-Version",
      "atlasPages": "Atlas-Seiten",
      "totalSize": "Gesamtgröße",
      "animationCount": "Animationsanzahl",
      "skinCount": "Skin-Anzahl",
      "playbackState": "Wiedergabestatus",
      "duration": "Dauer:",
      "time": "Zeit:",
      "errorInfo": "Fehlerinfo",
      "readError": "Fehler beim Lesen der Datei: ",
      "hintZoom": "Zum Zoomen scrollen",
      "hintPause": "Leertaste für Pause/Wiedergabe",
      "dropHere": "Maus loslassen, um Dateien zu laden",
      "notDetected": "Nicht erkannt"
    }
  },
  ru: {
    translation: {
      "title": "RunSpine - Онлайн Spine Viewer",
      "spineList": "Список Spine",
      "loadLocal": "Локально",
      "pmaTitle": "Предварительно умноженный альфа",
      "pma": "П",
      "bonesTitle": "Показать кости",
      "bones": "К",
      "boundsTitle": "Показать границы",
      "bounds": "Г",
      "fullscreenTitle": "Полный экран (F11)",
      "reset": "Сброс",
      "playback": "Воспроизведение",
      "viewSettings": "Настройки вида",
      "basicInfo": "Базовая инфо",
      "skin": "Скин:",
      "animation": "Анимация:",
      "default": "По умолчанию",
      "scaleRange": "Масштаб:",
      "min": "Мин:",
      "max": "Макс:",
      "speedRange": "Скорость:",
      "fullscreenSettings": "Полный экран:",
      "standardFs": "Стандартный",
      "borderlessFs": "Без рамок",
      "hideUiFs": "Скрыть UI",
      "welcomeTitle": "RunSpine Viewer",
      "tip1": "👉 Пробел для Воспроизведения/Паузы",
      "tip2": "📂 Перетащите папку сюда или нажмите Локально",
      "tip3": "🔧 Поддерживаемые версии: 3.8, 4.0, 4.1, 4.2",
      "ad": "Реклама",
      "errorMissingFiles": "Пожалуйста, предоставьте полный набор файлов Spine: включая .skel или .json, .atlas и все необходимые .png файлы.",
      "resourceInfo": "Инфо о ресурсе",
      "name": "Имя",
      "skeleton": "Скелет",
      "atlas": "Атлас",
      "source": "Источник",
      "sourceLocal": "Локальный файл",
      "sourceManifest": "Манифест",
      "spineVersion": "Версия Spine",
      "runtimeVersion": "Версия Runtime",
      "atlasPages": "Страницы атласа",
      "totalSize": "Общий размер",
      "animationCount": "Количество анимаций",
      "skinCount": "Количество скинов",
      "playbackState": "Состояние воспроизведения",
      "duration": "Длительность:",
      "time": "Время:",
      "errorInfo": "Информация об ошибке",
      "readError": "Не удалось прочитать файл: ",
      "hintZoom": "Скролл для зума",
      "hintPause": "Пробел для паузы/воспр.",
      "dropHere": "Отпустите мышь для загрузки",
      "notDetected": "Не обнаружено"
    }
  }
};

export async function initI18n() {
  const customLanguageDetector = {
    type: 'languageDetector',
    async: true,
    detect: async (callback: (lang: string) => void) => {
      const storedLang = localStorage.getItem('i18nextLng');
      if (storedLang) {
        return callback(storedLang);
      }

      try {
        const response = await fetch('https://ipapi.co/json/');
        if (response.ok) {
          const data = await response.json();
          const country = data.country_code;
          
          const countryToLang: Record<string, string> = {
            'CN': 'zh', 'TW': 'zh', 'HK': 'zh', 'MO': 'zh', 'SG': 'zh',
            'JP': 'ja',
            'KR': 'ko',
            'ES': 'es', 'MX': 'es', 'AR': 'es', 'CO': 'es', 'CL': 'es', 'PE': 'es',
            'FR': 'fr', 'BE': 'fr', 'CH': 'fr', 'CA': 'fr',
            'DE': 'de', 'AT': 'de',
            'RU': 'ru', 'BY': 'ru', 'KZ': 'ru'
          };

          if (country && countryToLang[country]) {
            return callback(countryToLang[country]);
          }
        }
      } catch (error) {
        console.warn('IP geolocation failed, falling back to browser language');
      }

      const browserLang = navigator.language.split('-')[0];
      callback(browserLang);
    },
    init: () => {},
    cacheUserLanguage: (lng: string) => {
      localStorage.setItem('i18nextLng', lng);
    }
  };

  i18next.use(customLanguageDetector as any);

  await i18next.init({
    resources,
    fallbackLng: 'en',
    supportedLngs: ['en', 'zh', 'ja', 'ko', 'es', 'fr', 'de', 'ru'],
    interpolation: {
      escapeValue: false
    }
  });

  return i18next;
}

export function updateDOM(i18n: any) {
  document.querySelectorAll('[data-i18n]').forEach((element) => {
    const key = element.getAttribute('data-i18n');
    if (key) {
      if (element.tagName === 'INPUT' && (element as HTMLInputElement).type === 'button') {
        (element as HTMLInputElement).value = i18n.t(key);
      } else {
        element.textContent = i18n.t(key);
      }
    }
  });
  
  document.querySelectorAll('[data-i18n-title]').forEach((element) => {
    const key = element.getAttribute('data-i18n-title');
    if (key) {
      element.setAttribute('title', i18n.t(key));
    }
  });
}
